import { useEffect, useState } from 'react'
import { usePreferredGenresContext } from '@/contexts/PreferredGenresContext'

/**
 * Hook to manage first-time genre setup experience
 */
export function useFirstTimeGenreSetup() {
  const { hasPreferredGenres, isFirstTimeUser, shouldShowSuggestions, isLoading } =
    usePreferredGenresContext()

  const [hasShownSetupModal, setHasShownSetupModal] = useState(false)
  const [showSetupModal, setShowSetupModal] = useState(false)

  // Show setup modal for first-time users with suggestions
  useEffect(() => {
    if (!isLoading && isFirstTimeUser && shouldShowSuggestions && !hasShownSetupModal) {
      setShowSetupModal(true)
      setHasShownSetupModal(true)
    }
  }, [isLoading, isFirstTimeUser, shouldShowSuggestions, hasShownSetupModal])

  const handleSetupComplete = () => {
    setShowSetupModal(false)
  }

  const handleSetupSkip = () => {
    setShowSetupModal(false)
  }

  const openSetupModal = () => {
    setShowSetupModal(true)
  }

  return {
    // State
    showSetupModal,
    isFirstTimeUser,
    hasPreferredGenres,
    shouldShowSuggestions,

    // Actions
    handleSetupComplete,
    handleSetupSkip,
    openSetupModal,

    // Loading
    isLoading,
  }
}
